import { render } from "./CustomBadge.vue?vue&type=template&id=185cb532&scoped=true"
import script from "./CustomBadge.vue?vue&type=script&lang=js"
export * from "./CustomBadge.vue?vue&type=script&lang=js"

import "./CustomBadge.vue?vue&type=style&index=0&id=185cb532&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185cb532"]])

export default __exports__